




































import { Component, Prop, Vue } from 'vue-property-decorator';

export interface IAuthor {
  avatar: string;
  nickname: string;
}

@Component
export default class Header extends Vue {
  public showButtons: boolean = false;
  @Prop() private version!: number;

  private readonly author: IAuthor = {
    avatar: 'https://pubg.disquse.ru/images/avatar.jpg',
    nickname: 'Disquse',
  };

  /**
   * Enabled header buttons if main is hidden while scrolling.
   * @returns {void}
   */
  public onScroll(e: any): void {
    this.showButtons = (e.pageY > 165);
  }

  /**
   * Sends event that request clear all action from Container.
   * @returns {void}
   */
  public callClearAll(): void {
    this.$root.$emit('requestClearAll');
  }

  /**
   * Sends event that request ping selected servers action from Container.
   * @returns {void}
   */
  public callPingSelected(): void {
    this.$root.$emit('requestPingSelected');
  }
}
